// extracted by mini-css-extract-plugin
export default {"accordionItem":"_0fct5","itemContent":"PyTnk","itemHeader":"_-7lRg","headerTitle":"_7UWqU","toggleButton":"yuPqK","toggleButtonToggled":"quFZj","skeleton-progress":"CVwhR"};